import React from 'react';
import { Navigate, Route, useParams } from 'react-router-dom';
import routes from 'components/App/components/routes';
import Support from './components/Support';
import ChartsTemplates from './components/ChartsTemplates/ChartsTemplates';
import ClientSupport, {
    DEFAULT_TAB,
} from './components/ClientSupport/ClientSupport';

const RedirectSupportToTab = () => {
    const { bind } = useParams();
    return <Navigate to={`/support/${bind}/${DEFAULT_TAB}`} replace />;
};

const SupportRoutes = [
    <Route
        path={routes.supportBindTab}
        key="client-support"
        element={<ClientSupport />}
    />,
    <Route
        path={routes.supportBind}
        key="client-support-redirect"
        element={<RedirectSupportToTab />}
    />,
    <Route path={routes.support} key="support" element={<Support />} />,
    <Route
        path={routes.chartsTemplates}
        key="charts-template-support"
        element={<ChartsTemplates />}
    />,
];
export default SupportRoutes;
